export default "__VITE_ASSET__c4060423__"